import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { StudentAssignmentGridDataService } from 'common/services/data-services/student/Student Assignment/student-assignment-data.service';

import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { StudentCompletedAssignmentDetailsDataService } from 'common/services/data-services/custom-service/StudentCompletedAssignmentDetails-services';
import { StudentInCompletedAssignmentDetailsDataService } from 'common/services/data-services/custom-service/StudentInCompletedAssignmentDetails-service';
import { StudentToDoAssignmentDetailsDataService } from 'common/services/data-services/custom-service/StudentToDoAssignmentDetails-service';
import { StudentUpcomingAssignmentDetailsDataService } from 'common/services/data-services/custom-service/StudentUpcomingAssignmentDetails-service';
import { StudentAssignmentModel } from 'common/models/page-models/Student Assignment/student-assignment-data.model';
import { studentAssignmentGridMetaModel } from 'common/models/page-models/Student Assignment/student-assignment-grid-meta.model';
import { StudentAssignmentListingModel } from 'common/models/page-models/Student Assignment/student-assignment-grid-model';

@Injectable({
  providedIn: 'root',
})
export class StudentAssignmentGridWidgetService extends GridWidgetService<
  StudentAssignmentModel,
  StudentAssignmentListingModel
> {
  constructor(
    protected override ds: StudentAssignmentGridDataService,
    protected systemService: SystemService,
    private StudentCompletedAssignmentDetails: StudentCompletedAssignmentDetailsDataService,
    private StudentInCompletedAssignmentDetails: StudentInCompletedAssignmentDetailsDataService,
    private StudentToDoAssignmentDetails: StudentToDoAssignmentDetailsDataService,
    private StudentUpcomingAssignmentDetails: StudentUpcomingAssignmentDetailsDataService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new studentAssignmentGridMetaModel().getMetaModel();
    return meta;
  }
  override prepareMetaModel(
    dataModel: StudentAssignmentModel,
    metaModel: studentAssignmentGridMetaModel,
    event: any = null
  ): Promise<SmMetaModel> {
    return new Promise<studentAssignmentGridMetaModel>((resolve, reject) => {
      // Define different payloads for each API call
      // const upcomingAssignmentsPayload = {
      //   pageNumber: 1,
      //   pageSize: 10,
      //   search_keyword: 0, 
      //   assignmentType:0 // Search keyword for upcoming assignments
      // };
  
      const completedAssignmentsPayload = {
        pageNumber: 1,
        pageSize: 10,
        search_keyword: 0,
        assignmentType:3  // Search keyword for completed assignments
      };
  
      const incompleteAssignmentsPayload = {
        pageNumber: 1,
        pageSize: 10,
        search_keyword: 0,  
        assignmentType:2// Search keyword for incomplete assignments
      };
  
      const todoAssignmentsPayload = {
        pageNumber: 1,
        pageSize: 10,
        search_keyword: 1,
        assignmentType:1

      };
  
      const fetchCompletedAssignments = this.StudentCompletedAssignmentDetails.postData(completedAssignmentsPayload);
      const fetchIncompleteAssignments = this.StudentInCompletedAssignmentDetails.postData(incompleteAssignmentsPayload);
      const fetchToDoAssignments = this.StudentToDoAssignmentDetails.postData(todoAssignmentsPayload);
  
      Promise.all([
        fetchCompletedAssignments,
        fetchIncompleteAssignments,
        // fetchUpcomingAssignments,
        fetchToDoAssignments,
      ])
        .then(([completedData, incompleteData,toDoData]) => {
          metaModel.properties.details.StudentCompletedAssignmentDetails = completedData;
          metaModel.properties.details.StudentInCompletedAssignmentDetails = incompleteData;
          // metaModel.properties.details.StudentUpcomingAssignmentDetails = upcomingData;
          metaModel.properties.details.StudentToDoAssignmentDetails = toDoData;
  
        
  
          resolve(metaModel);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}  